import React, { type FC, type MouseEvent, type PropsWithChildren, type ReactNode } from 'react'

import Popover from '../common/Popover'
import { AnchorProvider, useAnchor, useAnchorCloser, useAnchorSetter } from '../common/Anchor/Anchor'

type TriggerProps = Readonly<{ open: boolean, onClick: (e: MouseEvent<Element>) => void }>

type Props = Readonly<{ className: string, trigger: (props: TriggerProps) => ReactNode }> & PropsWithChildren

const Content: FC<Props> = ({ className, trigger, children }) => {
    const open = useAnchor() !== null
    const setOrigin = useAnchorSetter()
    const close = useAnchorCloser()

    return (
        <>
            {trigger({ open, onClick: (e) => setOrigin(e.currentTarget) })}
            <Popover
                className={className}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={close}
            >
                {children}
            </Popover>
        </>
    )
}

/** A popover that opens below the element rendered by the trigger when it is clicked */
export const AnchoredPopover: FC<Props> = (props) => (
    <AnchorProvider>
        <Content {...props} />
    </AnchorProvider>
)
